import {
  RECEIVE_KEY_VALUES,
  REQUEST_KEY_VALUES,
  KEY_VALUES_FAILED,
  REQUEST_CACHE,
  RECEIVE_CACHE,
  CACHE_FAILED,
  API_CALL
} from "./types";

export const updateKeyValues = keyName => ({
  type: API_CALL,
  onRequest: REQUEST_KEY_VALUES,
  onResponse: RECEIVE_KEY_VALUES,
  onError: KEY_VALUES_FAILED,
  responseKey: 'kvs',
  payload: {
    id: keyName,
    method: 'PUT',
    url: `/presets/thirdParty?keyName=${keyName}`
  },
  keyName
});

export const updateGamCache = () => ({
  type: API_CALL,
  onRequest: REQUEST_CACHE,
  onResponse: RECEIVE_CACHE,
  onError: CACHE_FAILED,
  responseKey: 'savecache',
  payload: {
    method: 'POST',
    url: `/savecache`
  },
});
